import React, { useState, useEffect } from "react";
import moment from "jalali-moment";
import { Calendar as BigCalendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { Modal, ModalHeader, ModalBody, Button, FormGroup, Label, Input, Spinner } from "reactstrap";
import axios from "axios"; 
import "../assets/css/customcss.css";
import apiConfig from "../config/apiConfig";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const localizer = momentLocalizer(moment);

function ReservationsSystemManagement() {
  const [calendarView, setCalendarView] = useState("month");
  const [selectedDate, setSelectedDate] = useState("");
  const [formModalOpen, setFormModalOpen] = useState(false);
  const [fetchedData, setFetchedData] = useState(null);
  const [highlightedDates, setHighlightedDates] = useState([]);
  const [formValues, setFormValues] = useState({
    session1: { meetingTime: "", startTime: "", endTime: "" },
    session2: { meetingTime: "", startTime: "", endTime: "" },
    session3: { meetingTime: "", startTime: "", endTime: "" },
    session4: { meetingTime: "", startTime: "", endTime: "" },
  });
  const [selectedAdditionalDates, setSelectedAdditionalDates] = useState([]);  
  const [currentMonthDates, setCurrentMonthDates] = useState([]);
  const [loading, setLoading] = useState(false); // وضعیت لودینگ
  const serverUrl = apiConfig.serverUrl;
  const [events, setEvents] = useState([]); // رویدادهای تقویم

  const toggleModal = () => setFormModalOpen(!formModalOpen);

  // دریافت تاریخ‌های ماه جاری
  useEffect(() => {
    const calculateDatesForMonth = (baseDate) => {
      const dates = [];
      const startOfMonth = moment(baseDate).startOf("month");
      const endOfMonth = moment(baseDate).endOf("month");
      for (let i = 0; i <= endOfMonth.diff(startOfMonth, "days"); i++) {
        dates.push(startOfMonth.clone().add(i, "days").format("YYYY/MM/DD"));
      }
      return dates;
    };
  
    const updateMonthDates = () => {
      const baseDate = selectedDate ? moment(selectedDate) : moment();
      setCurrentMonthDates(calculateDatesForMonth(baseDate));
    };
    
    updateMonthDates();
  
    const currentdat = moment().format("YYYY/MM/DD");
    
    axios
      .get(serverUrl + "get-reservations-system-management-panel", {
        headers: { dateee: currentdat },
      })
      .then((response) => {
        const data = response.data.ReservationSystemManagement2;
        setHighlightedDates(data.map(item => item.date)); // ذخیره تاریخ‌ها
        setFetchedData(data || []); // ذخیره داده‌ها در fetchedData
      })
      .catch((error) => {
        console.error("Error fetching reservation data:", error);
        setFetchedData([]); // در صورت بروز خطا، مقداردهی خالی
      });

  }, [selectedDate]);

  useEffect(() => {
    const addPersianDate = () => {
      const dateCells = document.querySelectorAll(".rbc-date-cell"); // سلول‌های مربوط به روزها
      dateCells.forEach((cell) => {
        const dateText = cell.innerText.trim(); // متن عدد میلادی
        if (dateText) {
          const persianDate = moment(dateText, "D").locale("fa").format("jD"); // تبدیل به شمسی

          // جلوگیری از تکرار اضافه کردن عدد شمسی
          if (!cell.querySelector(".persian-date")) {
            const persianDateSpan = document.createElement("span");
            persianDateSpan.className = "persian-date";
            persianDateSpan.style.color = "green"; // تغییر رنگ به سبز
            persianDateSpan.style.fontSize = "0.8em"; // تنظیم اندازه
            persianDateSpan.style.display = "block"; // نمایش تاریخ شمسی در خط جدید
            persianDateSpan.style.marginTop = "5px"; // فاصله بین تاریخ میلادی و شمسی
            persianDateSpan.innerText = persianDate;
            cell.appendChild(persianDateSpan); // اضافه کردن تاریخ شمسی زیر تاریخ میلادی
          }
        }
      });
    };

    setTimeout(addPersianDate, 0); // فراخوانی برای تاریخ شمسی
  }, [selectedDate]); 

  useEffect(() => {
    
    if (calendarView === "week") {
      const weeklyEvents = generateWeeklyEvents();
      setEvents([
        ...weeklyEvents
      ]);
    } else {
      setEvents([]);
    }
  }, [calendarView, fetchedData]);
  
  
  
  

  
  
  const fetchReservationData = (date) => {
    setLoading(true); // فعال کردن لودینگ
    axios
      .get(serverUrl + "get-reservations-system-management-panel", {
        headers: { dateee: date },
      })
      .then((response) => {
        const { ReservationSystemManagement } = response.data;

        if (ReservationSystemManagement) {
          const updatedFormValues = {
            session1: {
              meetingTime: ReservationSystemManagement.meeting_time || "",
              startTime: ReservationSystemManagement.start_time || "",
              endTime: ReservationSystemManagement.end_time || "",
            },
            session2: {
              meetingTime: ReservationSystemManagement.meeting_time2 || "",
              startTime: ReservationSystemManagement.start_time2 || "",
              endTime: ReservationSystemManagement.end_time2 || "",
            },
            session3: {
              meetingTime: ReservationSystemManagement.meeting_time3 || "",
              startTime: ReservationSystemManagement.start_time3 || "",
              endTime: ReservationSystemManagement.end_time3 || "",
            },
            session4: {
              meetingTime: ReservationSystemManagement.meeting_time4 || "",
              startTime: ReservationSystemManagement.start_time4 || "",
              endTime: ReservationSystemManagement.end_time4 || "",
            },
          };
          setFormValues(updatedFormValues);
        } else {
          setFormValues({
            session1: { meetingTime: "", startTime: "", endTime: "" },
            session2: { meetingTime: "", startTime: "", endTime: "" },
            session3: { meetingTime: "", startTime: "", endTime: "" },
            session4: { meetingTime: "", startTime: "", endTime: "" },
          });
        }
        setFetchedData(ReservationSystemManagement || null);
      })
      .catch((error) => {
        console.error("Error fetching reservation data:", error);
        setFetchedData(null);
      })
      .finally(() => {
        setLoading(false); // غیرفعال کردن لودینگ
      });
  };

  
  

  const handleDayClick = (date) => {
    const formattedDate = moment(date).startOf("day").format("YYYY/MM/DD");
    console.log("Clicked Date:", formattedDate);
    setSelectedDate(formattedDate);
    fetchReservationData(formattedDate); 
    toggleModal();
  };

  const handleFormChange = (e, session) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({
      ...prev,
      [session]: {
        ...prev[session],
        [name]: value,
      },
    }));
  };

  const handleAdditionalDateToggle = (date) => {
    if (date !== selectedDate) { // فقط در صورتی که تاریخ انتخاب شده نباشد، می‌توانیم آن را تغییر دهیم
      setSelectedAdditionalDates((prev) =>
        prev.includes(date)
          ? prev.filter((d) => d !== date) 
          : [...prev, date]  
      );
    }
  };

  const handleSave = (session) => {
    const dataToSave = formValues[session];

    if (!dataToSave.meetingTime || !dataToSave.startTime || !dataToSave.endTime) {
      toast.error("تمامی فیلدها باید پر شوند");
      return; // جلوگیری از ادامه ذخیره‌سازی
    }


    const formData = new FormData();
  
    formData.append("date", selectedDate);
    formData.append("session", session);
    formData.append("meetingTime", dataToSave.meetingTime || "");
    formData.append("startTime", dataToSave.startTime || "");
    formData.append("endTime", dataToSave.endTime || "");
  
    const additionalDatesForCurrentMonth = selectedAdditionalDates.filter((date) =>
      currentMonthDates.includes(date)
    );
    formData.append("additionalDates", JSON.stringify(additionalDatesForCurrentMonth));
  
    setLoading(true);
    axios
      .post(serverUrl + "reservations-system-management", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then(() => {
        toast.success(`تنظیمات سانس ${session} با موفقیت ذخیره شد`);
      })
      .catch((error) => {
        if (error.response && error.response.status === 400) {
          
          toast.error(error.response.data.message);
        } else {
          console.error(`Error saving session ${session}:`, error);
          alert(`خطا در ذخیره تنظیمات سانس ${session}. لطفاً دوباره امتحان کنید.`);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };
  

  
  const calculateSessionsCount = (startTime, endTime, meetingTime) => {
    // تبدیل startTime و endTime به دقیقه از ابتدای روز
    const startMinutes = moment(startTime, "HH:mm").hours() * 60 + moment(startTime, "HH:mm").minutes();
    const endMinutes = moment(endTime, "HH:mm").hours() * 60 + moment(endTime, "HH:mm").minutes();
  
    // محاسبه تعداد جلسات
    const sessionCount = Math.floor((endMinutes - startMinutes) / meetingTime);
    return sessionCount;
  };
  
  function generateWeeklyEvents() {
    const weeklyEvents = []; // آرایه برای ذخیره رویدادها
    const weekDates = []; // تاریخ‌های هفته جاری
    const reservations = fetchedData || []; // استفاده از داده‌های دریافت‌شده
    
    if (!Array.isArray(reservations)) {
      console.error('Reservations is not an array', reservations);
      return weeklyEvents; // اگر reservations آرایه نیست، خروجی خالی برمی‌گرداند
    }
  
    // محاسبه تاریخ‌های هفته جاری
    const startOfWeek = moment(selectedDate || new Date()).startOf("week");
    for (let i = 0; i < 7; i++) {
      weekDates.push(startOfWeek.clone().add(i, "days").format("YYYY/MM/DD"));
    }
  
    // پردازش رزروها برای هر روز از هفته
    for (let date of weekDates) {
      const dayReservations = reservations.filter((res) => res.date === date);
  
      if (dayReservations.length > 0) {
        for (let reservation of dayReservations) {
          const { start_time, end_time, meeting_time, meeting_time2, start_time2, end_time2, meeting_time3, start_time3, end_time3, meeting_time4, start_time4, end_time4 } = reservation;
  
          if (start_time && end_time && meeting_time) {
            // تبدیل تایم جلسه به دقیقه
            const meetingTimeInMinutes = parseInt(meeting_time, 10); // فرض بر اینکه meeting_time عدد است
  
            // محاسبه تعداد جلسات
            const numberOfSessions = calculateSessionsCount(start_time, end_time, meetingTimeInMinutes);
  
            weeklyEvents.push({
              title: `سانس 1 (${numberOfSessions} جلسه)`,
              start: moment(`${date} ${start_time}`, "YYYY/MM/DD HH:mm").toDate(),
              end: moment(`${date} ${end_time}`, "YYYY/MM/DD HH:mm").toDate(),
              meetingTime : meeting_time,
            });
          }
  
          if (start_time2 && end_time2 && meeting_time2) {
            const meetingTimeInMinutes = parseInt(meeting_time2, 10);
            const numberOfSessions = calculateSessionsCount(start_time2, end_time2, meetingTimeInMinutes);
  
            weeklyEvents.push({
              title: `سانس 2 (${numberOfSessions} جلسه)`,
              start: moment(`${date} ${start_time2}`, "YYYY/MM/DD HH:mm").toDate(),
              end: moment(`${date} ${end_time2}`, "YYYY/MM/DD HH:mm").toDate(),
              meetingTime: meeting_time2,
            });
          }
  
          if (start_time3 && end_time3 && meeting_time3) {
            const meetingTimeInMinutes = parseInt(meeting_time3, 10);
            const numberOfSessions = calculateSessionsCount(start_time3, end_time3, meetingTimeInMinutes);
  
            weeklyEvents.push({
              title: `سانس 3 (${numberOfSessions} جلسه)`,
              start: moment(`${date} ${start_time3}`, "YYYY/MM/DD HH:mm").toDate(),
              end: moment(`${date} ${end_time3}`, "YYYY/MM/DD HH:mm").toDate(),
              meetingTime: meeting_time3,
            });
          }
  
          if (start_time4 && end_time4 && meeting_time4) {
            const meetingTimeInMinutes = parseInt(meeting_time4, 10);
            const numberOfSessions = calculateSessionsCount(start_time4, end_time4, meetingTimeInMinutes);
  
            weeklyEvents.push({
              title: `سانس 4 (${numberOfSessions} جلسه)`,
              start: moment(`${date} ${start_time4}`, "YYYY/MM/DD HH:mm").toDate(),
              end: moment(`${date} ${end_time4}`, "YYYY/MM/DD HH:mm").toDate(),
              meetingTime: meeting_time4,
            });
          }
        }
      }
    }
  
    return weeklyEvents;
  }
  
  
  
  

  
  
  
  
  
  
  
  
  const meetingTimeOptions = [
    { label: "15 دقیقه", value: "15" },
    { label: "20 دقیقه", value: "20" },
    { label: "30 دقیقه", value: "30" },
    { label: "45 دقیقه", value: "45" },
    { label: "60 دقیقه", value: "60" },
  ];

  return (
    <>
      <ToastContainer />
      <div className="calendar-container" style={{maxWidth:'75%',marginRight:'20%',height:'100%'}}>
      <BigCalendar
  localizer={localizer}
  
  events={events || []}
  startAccessor="start"
  endAccessor="end"
  view={calendarView}
  onView={(view) => setCalendarView(view)}
  selectable
 
  dayPropGetter={(date) => {
    const formattedDate = moment(date).format("YYYY/MM/DD");
    if (highlightedDates.includes(formattedDate)) {
      return {
        style: { backgroundColor: "#ffeb3b" }, // رنگ پس‌زمینه خاص برای تاریخ‌های مورد نظر
        className: "highlighted-date", // کلاس CSS برای سفارشی‌سازی
      };
    }
    return {};
  }}
  onNavigate={(date) => {
    const newDate = moment(date).format("YYYY/MM/DD");
    setSelectedDate(newDate);
  }}
  onDrillDown={(date) => handleDayClick(date)}
  style={{ height: '100%' }}
  messages={{
    today: "امروز",
    previous: "قبلی",
    next: "بعدی",
    month: "ماه",
    week: "هفته",
    day: "روز",
    noEventsInRange: "رویدادی برای نمایش وجود ندارد",
  }}
  
/>


      </div>

      <Modal
        isOpen={formModalOpen}
        toggle={toggleModal}
        centered
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "800px",
          maxWidth: "90%",
          margin: "0 auto",
        }}
      >
        <ModalHeader toggle={toggleModal}>تعیین تایم جلسه‌ها - تاریخ: {selectedDate}</ModalHeader>
        <ModalBody
          style={{
            maxHeight: "70vh",
            overflowY: "auto",
          }}
        >
          {loading ? (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
              <div className="loading-spinner" style={{ marginBottom: "10px" }}></div>
              <p style={{ marginLeft: "10px" }}>در حال بارگذاری...</p>
            </div>
          ) : (
            <>
              {["session1", "session2", "session3", "session4"].map((session, index) => (
                <div key={session} className="session-form">
                  <h5
                    style={{
                      textAlign: "center",
                      color: "#007bff",
                      backgroundColor: "#f8f9fa",
                      padding: "10px",
                      borderRadius: "5px",
                      marginBottom: "15px",
                    }}
                  >
                    سانس {index + 1}
                  </h5>
                  <FormGroup>
                    <Label for={`${session}-meetingTime`}>تایم جلسه:</Label>
                    <Input
                      type="select"
                      name="meetingTime"
                      id={`${session}-meetingTime`}
                      value={formValues[session].meetingTime || ""}
                      onChange={(e) => handleFormChange(e, session)}
                      style={{ color: "black" }}
                    >
                      <option value="">انتخاب کنید</option>
                      {meetingTimeOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                  <FormGroup>
                    <Label for={`${session}-startTime`}>زمان شروع:</Label>
                    <Input
                      type="time"
                      name="startTime"
                      id={`${session}-startTime`}
                      value={formValues[session].startTime || ""}
                      onChange={(e) => handleFormChange(e, session)}
                      style={{ color: "black" }}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for={`${session}-endTime`}>زمان پایان:</Label>
                    <Input
                      type="time"
                      name="endTime"
                      id={`${session}-endTime`}
                      value={formValues[session].endTime || ""}
                      onChange={(e) => handleFormChange(e, session)}
                      style={{ color: "black" }}
                    />
                  </FormGroup>
                  <Button
                    color="primary"
                    onClick={() => handleSave(session)}
                    style={{ marginTop: "10px" }}
                  >
                    ذخیره سانس {index + 1}
                  </Button>
                  <hr />
                </div>
              ))}

              {/* فیلد انتخاب تاریخ‌های اضافی */}

              

              <FormGroup>
  <Label for="additionalDates">تاریخ‌های اضافی:</Label>
  <div
    className="additional-dates-container"
    style={{
      display: "grid",
      gridTemplateColumns: "repeat(7, 1fr)",
      gap: "8px",
      justifyContent: "center",
      border: "2px solid #ddd",
      padding: "15px",
      borderRadius: "8px",
      backgroundColor: "#f0f0f0",
      marginTop: "10px",
    }}
  >
    {currentMonthDates.map((date) => (
      <Button
        key={date}
        color={selectedAdditionalDates.includes(date) ? "success" : "secondary"}
        onClick={() => handleAdditionalDateToggle(date)}
        disabled={date === selectedDate}
        style={{
          margin: "0",
          fontSize: "12px",
          padding: "6px 12px",
          borderRadius: "5px",
          backgroundColor: selectedAdditionalDates.includes(date)
            ? "#28a745"
            : "#6c757d",
          color: "#fff",
        }}
      >
        {moment(date, "YYYY/MM/DD").date()} {/* شماره روز */}
      </Button>
    ))}
  </div>
              </FormGroup>

              <FormGroup>
  <Button
    color="danger"
    onClick={() => {
      // اینجا تابعی برای حذف تنظیمات روز اضافه کنید
      setLoading(true);
      axios
        .delete(serverUrl + "delete-reservations-system-management", {
          data: {
            date: selectedDate, // ارسال تاریخ اصلی
            additionalDates: selectedAdditionalDates.filter((date) =>
              currentMonthDates.includes(date) // اطمینان از ارسال فقط تاریخ‌های ماه جاری
            ), // ارسال تاریخ‌های اضافی
          },
        })
        .then(() => {
          toast.success("تنظیمات روز و تاریخ‌های اضافی با موفقیت حذف شد");
          toggleModal(); // بستن پاپ‌آپ
          setSelectedAdditionalDates([]); // پاک کردن تاریخ‌های اضافی انتخاب شده
        })
        .catch((error) => {
          console.error("Error deleting day settings:", error);
          toast.error("خطا در حذف تنظیمات روز");
        })
        .finally(() => {
          setLoading(false);
        });
    }}
    style={{ marginBottom: "15px" }}
  >
    حذف تنظیمات روز
  </Button>
</FormGroup>


            </>
          )}
        </ModalBody>
      </Modal>
    </>
  );
}

export default ReservationsSystemManagement;
